import { GlobalAppraisalDashboardList } from "components/appraisal/global/GlobalAppraisalDashboardList";
import { USAppraisalDashboardList } from "components/appraisal/us/USAppraisalDashboardList";
import { Unauthorized } from "layout/Unauthorized";
import { UserContext } from "redux/slices/userContextSlice";

const RootComponent = (props: { user: UserContext }) => {
   
    const hasAccess = () => {
        if((props.user?.isEMEA || props.user?.isAPAC) && props.user?.isUS){
            return <GlobalAppraisalDashboardList/>
        }
        if(props.user?.isEMEA || props.user?.isAPAC){
            return <GlobalAppraisalDashboardList/>
        }
        if(props.user?.isUS){
            return <USAppraisalDashboardList/>
        }
        return <><Unauthorized /></>
    }
    return <>
    {hasAccess()}
    </>;
  };
  
  export default RootComponent;